import api from '../api';

const BASE_URL = '/products/product-review';

const buildQueryParams = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ''
    ) {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};

export const productReviewAdminApi = {
  getPendingProducts: async (params = {}) => {
    const queryString = buildQueryParams(params);
    const url = queryString ? `${BASE_URL}/?${queryString}` : `${BASE_URL}/`;

    const response = await api.get(url);
    return response.data;
  },

  get: (id) => api.get(`/products/products-admin/${id}/`),

  submitReview: async (productId, payload) => {
    const response = await api.post(
      `${BASE_URL}/${productId}/submit/`,
      payload
    );
    return response.data;
  },

  getLastReview: async (productId) => {
    const response = await api.get(
      `${BASE_URL}/${productId}/last-review/`
    );
    return response.data;
  },
};
